// extracted by mini-css-extract-plugin
module.exports = {"layer-switch":"styles_layer-switch_1og7Q8zUvN2pyWIDqJL8AL","layerSwitch":"styles_layer-switch_1og7Q8zUvN2pyWIDqJL8AL"};